<template>
  <div>
    <resetPassword></resetPassword>
  </div>
</template>

<script>
import resetPassword from "./resetPassword.vue";

export default {
  name: "changepassword",

  components: {
    resetPassword,
  },

  data() {
    return {};
  },

  props: {},

  computed: {},

  watch: {},

  created() {},

  mounted() {},
};
</script>
